import { AxiosResponse } from "axios";
import { axiosConfigV2 } from "../../config/api/configApiv2";
import { axiosConfigToUpload } from "../../config/api/configApiUpload";

export const getCourseManagementList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/course-student-register/get-course-list`,
    payload
  );
};

export const getCourseStudentList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/course-student-register/get-by-course`, payload);
};

export const getEnrollmentRateStatistics: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2.get(
    `/course-student-register/get-ratio-by-registration-form/${id}`
  );
};

export const getStudyStatusRateStatistics: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2.get(
    `/course-student-register/get-ratio-by-learning-status/${id}`
  );
};

export const getStatisticByWeek: (id: number) => Promise<AxiosResponse<any>> = (
  id: number
) => {
  return axiosConfigV2.get(
    `/course-student-register/get-statistic-by-week/${id}`
  );
};

export const getStatisticByMonth: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2.get(
    `/course-student-register/get-statistic-by-month/${id}`
  );
};

export const getStatisticByYear: (id: number) => Promise<AxiosResponse<any>> = (
  id: number
) => {
  return axiosConfigV2.get(
    `/course-student-register/get-statistic-by-year/${id}`
  );
};
export const getStatisticByDate: (
  params: any
) => Promise<AxiosResponse<any>> = (params: any) => {
  return axiosConfigV2.get(
    `/course-student-register/get-statistic-by-date/${params}`
  );
};

export const getTranscriptList: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/course/scoreboard/get-scoreboard`, payload);
};

export const getQuizByCourse: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.get(`/mooc-course-unit/get-quiz-by-course/${id}`);
};

export const getTranscriptStatistic: (
  params: any
) => Promise<AxiosResponse<any>> = (params: any) => {
  return axiosConfigV2.get(`/manage-result/get-statistic-result/${params}`);
};

export const getGradeRatio: (id: any) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(`/manage-result/get-grade-ratio/${id}`);
};

//export
//Xuất dữ liệu excel thống kê đếm số lượng học viên ghi danh

export const exportExcelCount: (params: any) => Promise<AxiosResponse<any>> = (
  params
) => {
  return axiosConfigV2.get(
    `/course-student-register/export-excel-count/${params}`,
    {
      responseType: "arraybuffer",
    }
  );
};

//Xuất dữ liệu excel thống kê tỉ lệ hình thức ghi danh
export const exportExcelRegistrationForm: (
  id: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(
    `/course-student-register/export-excel-registration-form/${id}`,
    {
      responseType: "arraybuffer",
    }
  );
};
//Xuất dữ liệu excel thống kê tỉ lệ trạng thái học tập
export const exportExcelLearningStatus: (
  id: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(
    `/course-student-register/export-excel-learning-status/${id}`,
    {
      responseType: "arraybuffer",
    }
  );
};
//Xuất excel thống kê tỉ lệ điểm
export const exportExcelGradeRatio: (
  id: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(`/manage-result/export-excel-grade-ratio/${id}`, {
    responseType: "arraybuffer",
  });
};
//Xuất excel data biểu đồ điểm
export const exportExcelGradeCount: (
  params: any
) => Promise<AxiosResponse<any>> = (params) => {
  return axiosConfigV2.get(
    `/manage-result/export-excel-grade-count/${params}`,
    {
      responseType: "arraybuffer",
    }
  );
};

export const getStudentCertificate: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/course-student-register/get-student-certificate`,
    payload
  );
};

// đánh giá khoá học
export const getReviewAndDiscussionByCourse: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/course-review/get-review-and-discussion-by-course`,
    payload
  );
};

// đếm số đánh giá
export const countRatingByCourse: (
  params: any
) => Promise<AxiosResponse<any>> = (params) => {
  return axiosConfigV2.get(`/course-review/count-rating-by-course?${params}`);
};

export const replyFeedback: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.post(`/course-review/create-feedback`, payload);
};

export const removeFeedback: (id: number) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.delete(`/course-review/remove-comment/${id}`);
};

export const getAllDiscussionUnit: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/unit-discussion/get-all-by-unit-for-teacher`,
    payload
  );
};

export const getDiscussReport: (payload: any) => Promise<AxiosResponse<any>> = (
  payload
) => {
  return axiosConfigV2.post(`/unit-discussion/get-list-report`, payload);
};

// Danh sách học viên ghi danh
export const getRegisterStudentList: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(
    `/mooc-student-management/search-student-in-course`,
    data
  );
};

export const moocStudentManagementCountStudent: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(`/mooc-student-management/course-count`, data);
};

// Xóa học viên ghi danh
export const removeStudentFromCourse: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.delete(`/mooc-student-management/remove-student-from-course`, {data});
};

// Tiến độ học tập
export const studentProgressOverview: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(
    `/mooc-student-management/student-progress-overview`,
    data
  );
};

export const studentProgressDetail: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(
    `/mooc-student-management/student-progress-detail`,
    data
  );
};
export const getAttendanceStudentByCourse: (courseId: number, studentId : number) => Promise<AxiosResponse<any>> = (courseId, studentId ) => {
  return axiosConfigV2.get(`/mooc-attendance/get-attendance-student-by-course/${courseId}?studentId=${studentId}`);
}
export const updateUnitAttendance: (data: any) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.put(`/mooc-attendance/update-unit-attendance`, data);
}
export const exportAttendanceStudentByCourse: (courseId: number, studentId : number) => Promise<AxiosResponse<any>> = (courseId, studentId ) => {
  return axiosConfigV2.get(`/mooc-attendance/export-attendance-student-by-course/${courseId}?studentId=${studentId}`, {responseType: "arraybuffer"});
}

export const getAttendanceHistory: (courseId: number, studentId : number) => Promise<AxiosResponse<any>> = (courseId, studentId ) => {
  return axiosConfigV2.post(`/mooc-attendance/attendance-history/${courseId}?studentId=${studentId}`);
}

export const getDiscussById: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.post(`/unit-discussion/get-discussion-by-id/${id}`);
};

export const removeDiscussion: (id: number) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.delete(`/unit-discussion/remove/${id}`);
};

export const saveDiscussion: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.post(`/unit-discussion/save/${id}`);
};

export const unSaveDiscussion: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.delete(`/unit-discussion/un-save/${id}`);
};

export const seenComment: (id: any) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.put(`/unit-discussion/seen/${id}`);
};

export const getSavedDiscussion: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/unit-discussion/get-list-save`, payload);
};

export const getDetailReport: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.get(`/unit-discussion/get-report-by-id/${id}`);
};

export const processDiscussionReports: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/unit-discussion/processing-report`, payload);
};

export const countDiscussion: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.get(`/unit-discussion/get-statistic-by-unit/${id}`);
};

export const teacherReplyStudent: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigToUpload.post(`/unit-discussion/teacher-reply`, payload);
};

export const deleteTeacherReplyStudent: (
  id: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.delete(`/unit-discussion/delete/${id}`);
};

export const updateTeacherReplyStudent: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigToUpload.put(`/unit-discussion/update-comment`, payload);
};

export const exportStudentFile: (
  payload: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/mooc-student-management/export-student-in-course`,
    payload,
    {
      responseType: "arraybuffer",
    }
  );
};